import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { Logo } from "../Shared";

export default function Footer() {
  return (
    <footer className="mt-20 bg-emerald-950 text-stone-200" data-testid="site-footer">
      <div className="p1-container grid gap-10 py-14 md:grid-cols-4">
        <div>
          <Logo light />
          <p className="mt-2.5 text-sm font-medium tracking-wide text-stone-300" data-testid="footer-tagline">Care Today. Better Tomorrows.</p>
          <p className="mt-3 max-w-xs text-sm text-stone-300">
            Everything your parents need. One trusted team. Technology-enabled parent & elder-care management, launching in Jaipur.
          </p>
          <p className="mt-4 text-xs text-stone-400">PARENTONE CARE PRIVATE LIMITED</p>
        </div>
        <div>
          <p className="text-sm font-semibold text-white">Company</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About us</Link></li>
            <li><Link to="/careers" className="hover:text-white">Careers & Training</Link></li>
            <li><Link to="/care-manager" className="hover:text-white">Our Care Managers</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-sm font-semibold text-white">For you</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/for-families" className="hover:text-white">For Families & NRIs</Link></li>
            <li><Link to="/for-parents" className="hover:text-white">For Parents</Link></li>
            <li><Link to="/plans" className="hover:text-white">Plans & Pricing</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQs</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-sm font-semibold text-white">Reach us</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0" /> <span data-testid="footer-address">Plot No. 36, Prithviraj Nagar, Durgapura, Jaipur, Rajasthan – 302018</span></li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 shrink-0" /> <a href="tel:+918690545601" className="hover:text-white" data-testid="footer-phone-link">+91 86905 45601</a></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 shrink-0" /> <a href="mailto:contact@parentonecare.com" className="hover:text-white" data-testid="footer-email-link">contact@parentonecare.com</a></li>
          </ul>
          <p className="mt-4 text-xs leading-relaxed text-stone-400">
            ParentOne coordinates care. Clinical services are fulfilled by appropriately qualified third-party providers. Emergency coordination is not a replacement for government emergency services (112 / 108).
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="p1-container flex flex-wrap items-center justify-between gap-3 py-5 text-xs text-stone-400">
          <p>© {new Date().getFullYear()} ParentOne Care Private Limited. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms of Service</Link>
            <Link to="/data-deletion" className="hover:text-white" data-testid="footer-data-deletion-link">Data Deletion</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
